import { createContext } from 'preact';

const StorefrontRoutesContext = createContext({});

export default StorefrontRoutesContext;
